import Checkbox from "@mui/material/Checkbox";
import EditIcon from "@mui/icons-material/Edit";
import FormGroup from "@mui/material/FormGroup";
import { Grid, Typography, Skeleton } from "@mui/material";
import Preloader from "../../../Helpers/Preloader";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditDescription from "../Description/EditDescription";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddNewDescriptionModal from "../Description/AddNewDescriptionModal";

const AdditionalInput = ({ data, templateId, categoryId, lineUuid, onUpdate }) => {
  const [loader, setLoader] = useState(false);
  const latestInspectionResponseRef = useRef();
  const [descriptionData, setDescriptionData] = useState();
  const storeData = useSelector((state) => state.CommonReducer);
  const [showAddDescModal, setShowAddDesModal] = useState(false);
  const [inspectionResponse, setInspectionResponse] = useState();
  const [editDescriptionModal, setEditDescriptionModal] = useState(false);

  const handleClick = (e, item) => {
    const updatedValues = descriptionData.values.map((el) => el.uuid === item.uuid ? { ...el, is_selected: !el.is_selected, updated_at: new Date().toISOString().replace("T", " ").substring(0, 19) } : el);
    setDescriptionData((prev) => ({ ...prev, values: updatedValues }));
    if (typeof onUpdate === 'function') onUpdate(updatedValues)
  };

  const templateIdRef = useRef(templateId);
  const categoryIdRef = useRef(categoryId);
  const lineUuidRef = useRef(lineUuid);

  useEffect(() => {
    templateIdRef.current = templateId;
    categoryIdRef.current = categoryId;
    lineUuidRef.current = lineUuid;
  }, [data, templateId, categoryId, lineUuid]);

  useEffect(() => {
    if (storeData?.inspectionData?.data) {
      latestInspectionResponseRef.current = JSON.parse(JSON.stringify(storeData));
      setInspectionResponse(storeData); // for local rendering
      setLoader(false);
    }
  }, [storeData?.inspectionData?.data]);

  useEffect(() => {
    setDescriptionData(data);
  }, [data]);

  return (
    <>
      <Preloader showPreloader={loader} />
      <AddNewDescriptionModal
        showAddDescModal={showAddDescModal}
        setShowAddDesModal={setShowAddDesModal}
        descriptionData={descriptionData}
        inspectionResponse={inspectionResponse}
        templateId={templateId}
        categoryId={categoryId}
        lineUuid={lineUuid}
        isAdditionalInfo={true}
        currentAdditionalInputID={data?.uuid}
      />
      {editDescriptionModal && (
        <EditDescription
          setEditDescriptionModal={setEditDescriptionModal}
          setDescriptionData={setDescriptionData}
          editDescriptionModal={editDescriptionModal}
          descriptionData={descriptionData}
          setShowAddDesModal={setShowAddDesModal}
          data={data}
          showAddDescModal={showAddDescModal}
          inspectionResponse={inspectionResponse}
          templateId={templateId}
          categoryId={categoryId}
          lineUuid={lineUuid}
          isAdditionalInfo={true}
          currentAdditionalInputID={data?.uuid}
        />
      )}
      <Grid container className="container">
        <Grid item xs={12} className="line_detail_des_title">
          <span className="details_title">{data?.prompt}</span>
          <span className="details_action" id="edit_additional_description" onClick={() => setEditDescriptionModal(true)}>
            <EditIcon />
            Edit
          </span>
        </Grid>
        {descriptionData?.values?.filter((data) => data?.is_deleted !== 1)?.map((item, index) => (
          <Grid item xs={6} md={storeData?.reportSideBarActive ? 6 : 4} key={index}>
            <FormGroup>
              <FormControlLabel
                className="checkbox flex_start"
                control={loader ? (
                  <div style={{ padding: "8px 10px 8px 8px", height: "37.5px", width: "34px", marginLeft: "3px" }}><Skeleton variant="square" sx={{ borderRadius: "3px", mt: "2px" }} /></div> // Skeleton for checkbox
                ) : (
                  <Checkbox
                    sx={{
                      height: "37.5px !important",
                      width: "37.5px !important",
                      "& .MuiSvgIcon-root": { fontSize: "20px !important" },
                    }}
                    checked={item.is_selected}
                    onClick={(e) => handleClick(e, item)}
                  />
                )}
                label={item.value}
              />
            </FormGroup>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Typography className="line_details__add_btn" id="add_additional_description" onClick={() => setShowAddDesModal(true)}>
            <AddCircleIcon />
            <span className="line_details__add_text">Add new</span>
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default AdditionalInput;